import { render } from "./ParametroSistema.vue?vue&type=template&id=69f0a4f3&scoped=true"
import script from "./ParametroSistema.vue?vue&type=script&lang=js"
export * from "./ParametroSistema.vue?vue&type=script&lang=js"

import "./ParametroSistema.vue?vue&type=style&index=0&id=69f0a4f3&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f0a4f3"]])

export default __exports__